import '../scss/styles.scss'
import '@popperjs/core';
import 'bootstrap';
import { CollapseHeader, CustomModalTouch, Tooltip, VenueModal, VenuePopover } from './ui';

const process: any = { env: { NODE_ENV: 'production' } };
window["process"] = process;

function main() {
  console.log('starting main app...') 
  Tooltip();
  VenuePopover();
  VenueModal();
  CustomModalTouch();
  CollapseHeader();
}

main()
